import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { NetezzaTableDataset } from 'app/model/dataset/netezza.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(NetezzaTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class NetezzaTableDatasetAdapter extends TabularTypeDatasetAdapter<NetezzaTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: NetezzaTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(NetezzaTableDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: NetezzaTableDataset): Promise<NetezzaTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, NetezzaTableDataset.MODEL);
    }
}
